<template>
  <div class="app-silder">
    <div class="user-img-box box">
      <div class="box-inner">
        <img :src="avatar">
        <p>{{name}}</p>
        <p>{{$t('lang.silderPage6')}}:{{score?Math.floor(score * 10)/10:0}}</p>
        <a href="https://static.bingotalk.cn/teachers/平台使用指南(Platform User Guide).pdf" target="_blank" class="help-btn">{{$t('lang.silderPage7')}}</a>
      </div>
    </div>
    <ul class="silder-ul">
      <router-link tag="li" to="/index">{{$t('lang.silderPage1')}}</router-link>
      <router-link tag="li" to="/booking">{{$t('lang.silderPage2')}}</router-link>
      <router-link tag="li" to="/classroom">{{$t('lang.silderPage3')}}<i v-if="notReviews"><span v-if="notReviews<99">{{notReviews}}</span><span v-else>99</span></i></router-link>
      <router-link tag="li" to="/me">{{$t('lang.silderPage4')}}</router-link>
      <!-- <router-link tag="li" to="/payment">{{$t('lang.silderPage5')}}</router-link> -->
    </ul>
    <el-tooltip class="wechat-qr-tooltip" effect="dark"  placement="right">
      <div slot="content">{{$t('lang.qrTipLine1')}}<br/>{{$t('lang.qrTipLine2')}}</div>
      <div class="wechat-qr" />
    </el-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["name", "avatar", "notReviews", "score"])
  }
};
</script>

<style lang="scss">
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-silder {
  position: relative;
  width: 200px;
  float: left;
}
.user-img-box {
  width: 200px;
  height: 220px;
  background: url(~assets/images/userinfo-bg.png) center center no-repeat;
  background-size: cover;
  img {
    display: block;
    width: 73px;
    height: 73px;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.8);
  }
  p {
    text-align: center;
    font-size: 15px;
    color: $white;
    margin-top: 15px;
  }
}
.help-btn {
  display: inline-block;
  font-size: 15px;
  width: 90px;
  line-height: 26px;
  text-align: center;
  background: rgba(255, 164, 56, 0.5);
  border: 1px solid #fffaf4;
  border-radius: 20px;
  color: #fff;
  cursor: pointer;
  &:hover {
    background: rgba(255, 224, 186, 0.5);
  }
  &:active {
    background: rgba(255, 164, 56, 0.5);
  }
}
.silder-ul {
  padding: 20px 0px;
  border-bottom: 4px solid $baseColor;
  background-color: $white;
  li {
    width: 100%;
    height: 28px;
    line-height: 28px;
    color: $gray;
    text-align: center;
    margin: 20px 0px;
    cursor: pointer;
    @include userSelect;
    position: relative;
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: #ffa438;
      color: #fff;
      font-size: 10px;
      font-style: normal;
      margin-left: 5px;
      position: relative;
      line-height: 14px;
      padding: 2px;
      top: -1px;
    }
    &:hover {
      background: rgb(204, 204, 204);
    }
    &.router-link-active {
      background: rgba(255, 164, 56, 0.2);
    }
  }
}
.wechat-qr {
  position: absolute;
  bottom: -150px;
  left: 50%;
  width: 125px;
  height: 125px;
  background: url(~assets/images/wechat-qr.png) center center no-repeat;
  background-size: cover;
  border: 2px solid rgba(245,166,35,.6);
  border-radius: 10px;
  transform: translateX(-50%);
}
</style>




// WEBPACK FOOTER //
// src/components/app-silder/app-silder.vue